import * as React from "react";
import { Modal, Space, theme } from "antd";
import { ExclamationCircleFilled, ExportOutlined } from "@ant-design/icons";

import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZBadCalculatePlanning2 } from "../ZCalculatePlanning2";

type PropsModalBadCalc = {
  info: ZBadCalculatePlanning2 | null;
  close: () => void;
};

export const ModalBadCalc: React.FC<PropsModalBadCalc> = ({ info, close }) => {
  const { token } = theme.useToken();
  const componentsList = info?.faults;
  return (
    <Modal
      open={!!componentsList}
      onCancel={close}
      title={
        <Space>
          <ExclamationCircleFilled style={{ color: token.colorPrimary }} />
          <span>Расчет плана не выполнен</span>
        </Space>
      }
      centered
      cancelButtonProps={{ style: { display: "none" } }}
      okText="Закрыть"
      onOk={close}
    >
      <div>Выберите шаблон плана для следующих компонентов:</div>
      {componentsList?.map(({ componentEntityId, componentName }) => (
        <div key={componentEntityId}>
          {componentName}:{" "}
          <a
            href={makeUrl(PageUrl.entityCard, { id: componentEntityId })}
            target="_blank"
            rel="noreferrer"
          >
            Ссылка <ExportOutlined />
          </a>
        </div>
      ))}
    </Modal>
  );
};
